import { differenceInDays, parseISO } from 'date-fns';

import { computeDatesSince } from 'lib/utilities';
import { sortByProps } from '../../../lib/sortByProp.js';

const filterSearch = (filterValue) => (value) => {
  if (!filterValue) {
    return true;
  }
  return (value.computed || {}).searchString.includes(filterValue);
};

const stableObject = {};

const filterStage = (filterValue) => (value) => {
  if (!filterValue) {
    return true;
  }
  return String((value || stableObject).stage_id) === String(filterValue);
};

const filterTodo = (filterValue) => (value) => {
  if (!filterValue) {
    return true;
  }
  return (value.computed || {}).overdueTodos > 0;
};

const filterUnreadMessages = (filterValue) => (value) => {
  return !filterValue || (value.computed || {}).unreadMessages > 0;
};

const filterOverdueActions = (filterValue) => (value) => {
  return filterValue !== 'overdue' || value.next_stage_overdue === true || (value.actions || []).filter((n) => n.status === 'overdue').length > 0;
};

const filterServiceInterest = (serviceId) => (value) => {
  return !serviceId || ((value || {}).service_interests || []).find((n) => n.service_offered_id === serviceId);
};

const filterDaysSince = (lastActivityDays) => (value) => {
  if (!lastActivityDays) {
    return true;
  }
  return (value.computed || {}).lastActivityDays <= lastActivityDays;
};

const filterUser = (userId) => (value) => {
  return !userId || String(((value || {}).user || {}).id) === String(userId);
};

const filterLocation = (locationId) => (value) => {
  return !locationId || (value || {}).service_location_id === locationId;
};

const filterServicePerson = (servicePersonId) => (value) => {
  return !servicePersonId || (value || {}).service_person_id === servicePersonId;
};

const filterLastContactedOrReceived = (filterValue, type) => (value) => {
  if (!filterValue) {
    return true;
  }
  const lastOutgoing = (value.computed || {}).lastOutgoing;
  const lastIncoming = (value.computed || {}).lastIncoming;
  if (filterValue === -1) {
    return (!lastOutgoing && type === 'lastContacted') || (!lastIncoming && type === 'lastReceived');
  }
  let val = computeDatesSince(lastOutgoing, lastIncoming);
  if (val.type === 'outbound' && type === 'lastContacted') {
    return differenceInDays(new Date(), parseISO(val.last_datetime)) >= filterValue;
  }
  return differenceInDays(new Date(), parseISO(val.last_datetime)) >= filterValue;
};

const filterActive = () => (value) => {
  return (value || {}).status_id === '1';
};

export const filterPipelineLeads = (pipelineSet, filters) => {
  const filteredSet = pipelineSet
    .filter(filterActive())
    .filter(filterStage(filters.pipelineStageId || ''))
    .filter(filterSearch(String(filters.search || '').toLowerCase()))
    .filter(filterTodo(filters.pipelineTodos))
    .filter(filterUnreadMessages(filters.hasUnreadInbox))
    .filter(filterOverdueActions(filters.overdueActions))
    .filter(filterServiceInterest(filters.serviceId))
    .filter(filterDaysSince(filters.pipelineItemLastActivity))
    .filter(filterUser(filters.userId))
    .filter(filterLocation(filters.locationId))
    .filter(filterServicePerson(filters.servicePersonId))
    .filter(filterLastContactedOrReceived(filters.lastContacted, 'lastContacted'))
    .filter(filterLastContactedOrReceived(filters.lastReceived, 'lastReceived'));
  const result = filteredSet.sort(sortByProps(['sub_status_id', (n) => n.computed.lastIncoming || '', 'computed.lastActivityDays'], ['asc', 'desc', 'asc']));
  return result;
};

export default filterPipelineLeads;
